import styled from "styled-components";
import {Container} from "@mui/material";
import {CheckboxInput} from "../../../components/Inputs/CheckboxInput";
import {StyledButton} from "../../../components/Buttons/DefaultButton/DefaultButton.styles";

export const BasicContainer = styled(Container)`
    overflow: auto;
    height: 100%;
    padding-bottom: 1rem;
`

const cardStyle = `
    background: #FFFFFF;
    margin: 1rem;
    border-radius: 0.5rem;
    border: 1px solid #E0E0E0;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
`

export const AddressSection = styled.div`
    ${cardStyle}
    display: flex;
    justify-content: space-between;
    padding: 1rem;
    .subtitle {
        color: var(--text-secondary);
    }
`

export const DateSection = styled.div`
    ${cardStyle}
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .calendar-date {
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }
`

export const BillingSection = styled.div`
    ${cardStyle}
    padding: 1rem;
`

export const PaymentSection = styled.div`
    ${cardStyle}
    padding: 1rem;
`

export const BillingRow = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 0;
    &:last-child {
        border-top: 1px solid #EEEEEE;
    }
    color: var(--text-secondary);
    &.grand-total {
        font-weight: 600 !important;
        color: var(--text-primary) !important;
        margin-top: 0.5rem;
    }
`

export const SectionTitle = styled.div`
    font-weight: 600;
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    &.title {
        margin-bottom: 0.25rem;
        font-size: 1rem;
    }
`

export const PaymentInfo = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 0.5rem 0;
    div .payment-terms {
        font-weight: 600 !important;
        color: var(--info-main) !important;
        text-transform: lowercase;

    }
`

export const StyledCheckboxInput = styled(CheckboxInput)`
    ${cardStyle}
    padding: 1rem;
    font-size: var(--input-helper-size);
`

export const PayNowButton = styled(StyledButton)`
    width: calc(100% - 2rem);
    margin: 1rem;
    background: var(--primary-blue);
    color: white;
    &:hover {
        background: #3367D6;
    }
`

export const AlreadyPaidButton = styled(StyledButton)`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    width: calc(100% - 2rem);
    margin: 1rem;
    color: var(--primary-blue);
    background: transparent;
    border: 1px solid var(--primary-blue);
`

export const PaymentNote = styled.div`
    margin: 1rem;
    font-size: var(--input-helper-size);
    color: #666666;
    line-height: 1.4;
`

export const ShiftContainer = styled.div`
    padding: 1.275rem 1rem;
    border-radius: var(--2, 1rem);
    background: var(--background-main, #FFF4F4);
    margin-bottom: 1rem;
`